var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro-pvtn", {
            attrs: { filtro: _vm.filtro, placeholder: "Informe o ano" },
            on: { pesquisar: _vm.pesquisar, limpar: _vm.limpar }
          })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            { attrs: { id: "tableHeader" } },
            [
              _c("h3", { staticStyle: { marginTop: "1%", marginLeft: "1%" } }, [
                _vm._v("Listagem")
              ]),
              _c(
                "el-button",
                {
                  attrs: {
                    id: "addPvtnButton",
                    type: "primary",
                    round: "round",
                    size: "medium"
                  },
                  on: { click: _vm.adicionarPvtn }
                },
                [_vm._v("Adicionar PVTN +")]
              )
            ],
            1
          ),
          _c("table-generica", {
            attrs: {
              colunas: _vm.colunas,
              botoesAcao: _vm.botoesAcao,
              dados: _vm.pvtns
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf2b2278", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf2b2278","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/ConfigurarVtn.vue
// module id = null
// module chunks = 